export interface SendEmailDialogFormFields {
    recipients: Contact[];
    ccs: Contact[];
    sendMeACopy: boolean;
    subject: string;
    body: string;
}

export interface Contact {
    displayName: string;
    emailAddress: string;
}

export interface Recipient extends Contact {
    deliveryFailed?: boolean;
    errorMessage?: string;
}
